module.exports = __webpack_public_path__ + "static/Tablet_mobile-c3a23f600c7035000fce5ac412ad36c9.mp4";